/**
 * Text for a place SweetAlert2 renders as HTML (`html`, `title`, `showValidationMessage()`): backend text and user
 * data go through here, so markup in them shows as text.
 */
export const escapeHtml = (value: string): string =>
  value
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/"/g, '&quot;')
    .replace(/'/g, '&#39;')
